import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReservationsImportService } from 'OpsCenter/merchants/importing/reservations/reservations-import.service';

@Component({
  selector: 'app-reservations-import',
  template: require('./reservations-import.component.html'),
})
export class ReservationsImportComponent {
  private merchantId: number = null;
  private email: string = null;
  private fileToUpload: File = null;
  private importResponseMessages: string[] = [];
  private isLoading = false;

  @ViewChild('fileInput', {static: false})
  private fileInput: HTMLInputElement;

  constructor(private reservationImportService: ReservationsImportService, private notificationService: ToastrService) {}

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  uploadFile() {
    if (this.isLoading) {
      return;
    }

    this.enableLoading();
    this.importResponseMessages = [];
    this.reservationImportService
      .uploadFile(this.merchantId, this.email, this.fileToUpload)
      .subscribe(() => this.handleUploadSuccess(), res => this.handleUploadError(res));
  }

  private handleUploadSuccess() {
    this.notificationService.success(`The file will be processed and you will receive an email with the result of the operation`);
    this.clearForm();
    this.disableLoading();
  }

  private handleUploadError(res) {
    if (res.status === 404) {
      this.importResponseMessages = ['Merchant not found'];
    } else {
      this.importResponseMessages = res.error.errors.map(error => error.message);
    }
    this.notificationService.error(`There were errors on the import operation. Please review and fix them before trying again`);
    this.disableLoading();
  }

  private clearForm() {
    this.merchantId = null;
    this.email = null;
    this.fileToUpload = null;
    this.fileInput.value = '';
  }

  private enableLoading() {
    this.isLoading = true;
  }

  private disableLoading() {
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/importing/reservations/reservations-import.component.ts